"use client";

import type { AuthTokenData } from "@/auth";
import { OnlyClient } from "@/components/OnlyClient";
import { authStore } from "@/store/authStore";
import { useCreation } from "ahooks";

export function AuthInit({ authTokenData }: { authTokenData?: AuthTokenData }) {
  return (
    <OnlyClient>
      <Init authTokenData={authTokenData} />
    </OnlyClient>
  );
}

function Init({ authTokenData }: { authTokenData?: AuthTokenData }) {
  useCreation(() => {
    authStore.setTokenData(authTokenData);
  }, [authTokenData]);

  return null;
}
